<template>
  <v-text-field
    type="password"
    label="Password"
    placeholder="Enter your password"
    prepend-inner-icon="mdi-lock"
    clearable
  />
</template>
